import { Provider } from '@angular/core';
import { PERSISTED_SLICES, PersistedSlice } from '../../oidc/store/persisted-state';
import * as tileFeature from './tile.reducer';

export const provideTilePersistence = (): Provider => ({
  provide: PERSISTED_SLICES,
  multi: true,
  useValue: {
    name: tileFeature.name,
    reshape: (stored: unknown): tileFeature.TilesState => {
      if(stored === null) {
        return tileFeature.initialState;
      }
      return stored as tileFeature.TilesState;
    },
  } satisfies PersistedSlice<tileFeature.TilesState>,
});
